<template>
  <div>
    <b-row>
      <b-col
        v-for="item in correspondencias"
        :key="item.id"
        cols="12"
        md="4"
        class="d-flex"
      >
        <b-card
          :title="item.remetente"
          class="w-100"
        >
          <b-row>
            <b-col align="left">
              <b-badge
                size="xs"
                variant="primary"
              >{{
                item.destinatario
              }}</b-badge>
            </b-col>
            <b-col align="right">
              <b-button
                variant="outline-primary"
                size="sm"
                align="right"
                :to="`/correspondencia/${item.id}`"
              >
                ver <feather-icon icon="ArrowRightIcon" />
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <infinite-loading @infinite="infiniteHandler">
      <div slot="no-more">
        Já carregamos todas as correspondencias =)
      </div>
      <no-content-correspondencia slot="no-results" />
      <div slot="spinner">
        Carregando...
      </div>
    </infinite-loading>
  </div>
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading'
import NoContentCorrespondencia from './NoContentCorrespondencia.vue'

export default {
  components: {
    InfiniteLoading,
    NoContentCorrespondencia,
  },
  data() {
    return {
      pagination: { page: 1, size: 10 },
    }
  },
  computed: {
    correspondencias() {
      return this.$store.state.correspondencia.correspondencias
    },
  },
  beforeCreate() {
    this.$store.dispatch('correspondencia/clear')
  },
  methods: {
    infiniteHandler($state) {
      this.$store
        .dispatch('correspondencia/fetchAll', { pagina: this.pagination.page })
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.pagination.page += 1
            $state.loaded()
          } else {
            $state.complete()
          }
        })
        .catch(() => $state.complete())
    },
  },
}
</script>
